<script setup lang="ts">
import { computed, useSlots } from 'vue';

interface Props {
  percentage: number;
  backgroundColor: string;
  backgroundFill: string;
  textColor?: string;
  textClass?: string;
  average?: number;
}
const slots = useSlots();
const props = defineProps<Props>();
const percentageAsText = computed((): string => `${Math.floor(props.percentage)}%`);
const hasDefaultSlot = computed(() => !!slots.default);
const style = computed((): string => `max-width: ${props.percentage}%`);
const averageLineStyle = computed(() => props.average !== undefined ? `left: ${props.average}%` : '');
</script>

<template>
  <div
    class="tw-w-full tw-rounded-full tw-relative"
    :class="backgroundFill"
  >
    <div
      id="percentage-bar"
      class="
        tw-transition-all
        tw-duration-500
        tw-w-full
        tw-text-xs
        tw-font-semibold
        tw-text-center
        tw-p-0.5
        tw-leading-none
        tw-rounded-l-full
      "
      :class="[backgroundColor, textColor]"
      :style="style"
    >
      <template v-if="textColor">
        <span
          :class="textClass"
          v-if="hasDefaultSlot"
        >
          <slot />
        </span>
        <span
          v-else
          :class="textClass"
        >
          {{ percentageAsText }}
        </span>
      </template>
    </div>
    <div
      v-if="average"
      class="tw-absolute tw-top-0 tw-bottom-0 tw-w-[2px] tw-bg-connx-white tw-z-50"
      :style="averageLineStyle"
    />
  </div>
</template>
